/* datas */
import { GetAllEntities } from '../../Admin/Functions/GetAllEntities.js';
import { GetRoutesTest } from '../../Admin/Functions/GetRoutesTest.js';

export const BlockMenuAdmin = (props) => {
    const { label, showSub, setShowSub } = props;
    let datas, val, sub;
    if (label === 'testroutes') {
        datas = GetRoutesTest();
        val = { nb: 1, title: 'Test routes' };
    }
    if (label === 'entities') {
        datas = GetAllEntities()[0];
        val = { nb: 2, title: 'Entities' };
    }
    if (label === 'attributes') {
        datas = GetAllEntities()[1];
        val = { nb: 3, title: 'Attributes' };
    }
    if (label === 'describes') {
        datas = GetAllEntities()[2];
        val = { nb: 4, title: 'Describes' };
    }
    return (
        <div className="nav-container">
            <div className="link" onClick={() => { setShowSub(val.nb) }}>{val.title}</div>
            <div className={`nav-2 ${showSub === val.nb ? 'show' : 'hide'}`}>
                <div className="nav-parent">
                    {datas.map((el, i) => {
                        if (label === 'describes') {
                            sub = {
                                name: `describe_${el.split('describe')[1]}`,
                                route: `/admin/entity/collection/describe_${el.split('describe')[1]}`,
                            };
                        }
                        if (label === 'entities' || label === 'attributes') {
                            sub = {
                                name: el,
                                route: `/admin/entity/collection/${el}`,
                            };
                        }
                        if (label === 'testroutes') {
                            sub = {
                                name: el.name,
                                route: el.route,
                            }
                        }
                        return (
                            <a className="link" href={sub.route} key={i}>{sub.name}</a>
                        )
                    })}
                </div>

            </div>
        </div>
    )
}